import { FC, useEffect } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

export interface ModalProps extends ReactModalProps {
  closeButton?: boolean;
  overlayZIndex?: number;
}

const Modal: FC<ModalProps> = ({
  children,
  style,
  preventScroll,
  closeButton,
  className = '',
  overlayZIndex,
  ...props
}) => {
  const [isDesktopSize] = useMediaQuery(desktop);

  const modalStyle: ReactModalProps['style'] = {
    overlay: {
      zIndex: overlayZIndex ?? 51,
      backgroundColor: 'rgba(127 ,127, 127, .3)',
      ...style?.overlay,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      maxWidth: isDesktopSize ? 800 : '100%',
      position: 'relative',
      padding: 0,
      outline: 'none',
      ...style?.content,
    },
  };

  useEffect(() => {
    if (preventScroll) document.body.style.overflow = props.isOpen ? 'hidden' : 'auto';
  }, [props.isOpen, preventScroll]);

  return (
    <ReactModal
      {...props}
      ariaHideApp={false}
      style={modalStyle}
      preventScroll={preventScroll}
      className={`${className} relative overflow-hidden rounded-2xl bg-white`}
      parentSelector={() => document.getElementById('react-modal-custom-portal') ?? document.body}
    >
      {closeButton && (
        <button onClick={props.onRequestClose} aria-label="Close" className="absolute right-20 top-20 z-[60] focus:ring-1">
          <CloseIcon className="size-24 text-gray-600" data-testid="close-modal" data-ffid="btn-close-modal-1" />
        </button>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
